import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {AuthService, IAuthenticationResult } from "../../../core/services/auth.service";
import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';
import {Inject} from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../../core/configs/app-config';
import { Router } from '@angular/router';


@Component({
    selector     : 'login',
    templateUrl  : './login.component.html',
    styleUrls    : ['./login.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations   : fuseAnimations
})
export class LoginComponent implements OnInit
{
    
    loginForm: FormGroup;
    config: any;

    constructor(
        private router: Router,
        private _fuseConfigService: FuseConfigService,
        private _formBuilder: FormBuilder,
        private authService: AuthService,
        @Inject(HttpClient)private http?: HttpClient,
        
        
    )
    {this.config = {
        "SERVERPROTOCOL": AppConfig.ApiProtocol,
        "SERVERURL": AppConfig.ApiLoginHost,
        "SERVERPORT": AppConfig.ApiPort,
        "APPLICATIONID": AppConfig.ApiApplicationId,
        "METHOD": AppConfig.ApiMethod,
        "LOGINURL": AppConfig.ApiLoginUrl,
        "STACKURL": AppConfig.ApiUrl
      },
        // Configure the layout
        this._fuseConfigService.config = {
            layout: {
                navbar   : {
                    hidden: true
                },
                toolbar  : {
                    hidden: true
                },
                footer   : {
                    hidden: true
                },
                sidepanel: {
                    hidden: true
                }
            }
        };
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        this.loginForm = this._formBuilder.group({
            email   : ['', [Validators.required, Validators.email]],
            password: ['', Validators.required]
        });
    }

      showAlert: boolean = false;

    async btnLogin() {
        if ( this.loginForm.invalid )
        {
            return;
        }

        this.showAlert = false;
        await this.authService.login(this.loginForm.get('email').value,this.loginForm.get('password').value).then((response: any) => {
            console.log("777777777777777777777777");
            console.log(response);
            if (this.authService.isAuthenticated()) {
                this.router.navigate(['/home']);
              }
         }, (error: IAuthenticationResult) => {
            

            // Show the alert
            this.showAlert = true;
         // this.errorMsg = "Error";
          console.log(error)
    
        }) 
        console.log("second");
    }

}
